import {
  INFRASTRUCTURE_TYPE_TO_TITLE_MAP,
  INSIDE_INFRASTRUCTURE_TYPE_TO_PROPERTY_MAP,
  OUTSIDE_INFRASTRUCTURE_TYPE_TO_PROPERTY_MAP,
  POSSIBLE_INSIDE_INFRASTRUCTURE_TYPES,
  POSSIBLE_OUTSIDE_INFRASTRUCTURE_TYPES,
} from 'shared/constants/transportAccessibilityInfrastructure';
import { IBaseTransportAccessibilityItemSchema } from 'shared/repositories/newbuilding-card/entities/get_infrastructure/BaseTransportAccessibilityItemSchema';
import { IMetroSchema } from 'shared/repositories/newbuilding-card/entities/get_infrastructure/MetroSchema';
import { ITransportAccessibilitySchema } from 'shared/repositories/newbuilding-card/entities/get_infrastructure/TransportAccessibilitySchema';
import { ITransportStopSchema } from 'shared/repositories/newbuilding-card/entities/get_infrastructure/TransportStopSchema';
import { ITAInfrastructure, TTAInfrastructureItem, TTAInfrastructureType } from 'shared/types/map';

export const transformTransportAccessibilityInfrastructure = (
  response: ITransportAccessibilitySchema | undefined,
): ITAInfrastructure | undefined => {
  if (!response) {
    return undefined;
  }

  const { inside, outside } = response;

  const outsideResult: Record<string, TTAInfrastructureItem[]> = {};
  const insideResult: Record<string, TTAInfrastructureItem[]> = {};

  if (outside) {
    POSSIBLE_OUTSIDE_INFRASTRUCTURE_TYPES.forEach(infrastructureType => {
      const property = OUTSIDE_INFRASTRUCTURE_TYPE_TO_PROPERTY_MAP[infrastructureType];
      const responseItems = outside[property];

      if (Array.isArray(responseItems)) {
        outsideResult[property] = responseItems.map(item => transformItem(item, infrastructureType));
      }
    });
  }

  if (inside) {
    POSSIBLE_INSIDE_INFRASTRUCTURE_TYPES.forEach(infrastructureType => {
      const property = INSIDE_INFRASTRUCTURE_TYPE_TO_PROPERTY_MAP[infrastructureType];
      // @ts-ignore TODO: Ошибка уйдет при подключении реальных данных в CD-170061
      const responseItems = inside[property];

      if (Array.isArray(responseItems)) {
        const resultItems = responseItems.map(item => transformItem(item, infrastructureType));

        insideResult[property] = resultItems;
      }
    });
  }

  return {
    inside: insideResult,
    outside: outsideResult,
  };
};

function transformItem(
  item: IBaseTransportAccessibilityItemSchema | ITransportStopSchema | IMetroSchema,
  infrastructureType: TTAInfrastructureType,
): TTAInfrastructureItem {
  return {
    ...item,
    type: infrastructureType,
    title: ('title' in item && (item.title as string)) || INFRASTRUCTURE_TYPE_TO_TITLE_MAP[infrastructureType],
  };
}
